const MONTH_NAME_TO_NUM = {
  All: "All",
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

const BRANCH_NAME_TO_CODE = {
  All: "All",
  MUMBAI: "B001",
  KOLKATA: "B002",
  DELHI: "B003",
  CHENNAI: "B004",
  LUCKNOW: "B010",
};

const CLUSTER_NAME_TO_CODE = {
  All: "All",
  "TAMIL NADU": "CL01",
  KARNATAKA: "CL02",
  "ANDHRA PRADESH": "CL03",
  GUJARAT: "CL04",
  "MUMBAI-PUNE": "CL05",
  "GREATER MAHARASHTRA": "CL06",
  "DELHI-GREATER DELHI": "CL07",
  "PUNJAB-HARYANA-HILLS": "CL08",
  "WEST BENGAL": "CL09",
  "ORISSA-JHARKHAND": "CL10",
  NESA: "CL11",
  "UTTAR PRADESH": "CL12",
  BIHAR: "CL13",
  "MP-CHG": "CL14",
  KERALA: "CL15",
  RAJASTHAN: "CL16",
};

export function monthFilterValueConvert(monthState) {
  return monthState
    .split(",")
    .map((item) => MONTH_NAME_TO_NUM[item])
    .join(",");
}

export function branchFilterValueConvert(branchState) {
  return branchState
    .split(",")
    .map((item) => BRANCH_NAME_TO_CODE[item] || item)
    .join(",");
}

export function clusterFilterValueConvert(clusterState) {
  return clusterState
    .split(",")
    .map((item) => CLUSTER_NAME_TO_CODE[item] || item)
    .join(",");
}